export const API_BASE_URL = "https://api.ansera.ai/api"

export const FAST_API_BASE_URL =process.env.REACT_APP_FAST_API_BASE_URL

// export const FAST_API_BASE_URL = " https://ventless-realterable-leonarda.ngrok-free.dev"
export  const LAMBDA_BASE_URL = process.env.REACT_APP_LAMBDA_BASE_URL

